import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { SignatureSection } from '../SignatureSection';

export const ContractCharacteristics = ({ data, type }) => {
    const characteristics = [
        "1. Objeto",
        "2. Contraprestación, pagos y comisiones",
        "3. Vigencia",
        "4. Formas para entregar el bien",
        "5. Intereses moratorios",
        "6. Depósito en garantía, consecuencias por daño, deterioro, destrucción o pérdida del bien arrendado",
        "7. Dispositivo de Geolocalización, mantenimiento, accidentes y uso del bien arrendado",
        "8. Revisiones",
        "9. Responsabilidad del Arrendatario",
        "10. Obligación Solidaria",
        "11. Confidencialidad",
        "12. Protección de datos personales",
        "13. Responsabilidad laboral",
        "14. Seguros",
        "15. Pagaré",
        "16. Terminación anticipada y rescisión",
        "17. Compra del bien Arrendado",
        "18. Subarrendamiento",
        "19. Impuestos",
        "20. Cesión",
        "21. Modificaciones",
        "22. Integridad del Contrato",
        "23. Notificaciones y domicilios"
    ];

    // Split into three columns (Custom distribution: 7, 9, 7)
    const col1 = characteristics.slice(0, 7);
    const col2 = characteristics.slice(7, 16);
    const col3 = characteristics.slice(16);

    return (
        <View style={[
            { marginTop: 10 },
            type === 'PF' && { flex: 1, justifyContent: 'space-between' }
        ]}>
            <Text style={[styles.tableTitle, { marginTop: type === 'PF' ? 70 : 5 }]}>DE LAS CARACTERÍSTICAS DEL CONTRATO</Text>
            <View style={{ flexDirection: 'row', fontSize: 7, marginLeft: 10, justifyContent: 'space-between' }}>
                <View style={{ width: '32%' }}>
                    {col1.map((item, index) => (
                        <Text key={index} style={{ marginBottom: 2 }}>{item}</Text>
                    ))}
                </View>
                <View style={{ width: '32%' }}>
                    {col2.map((item, index) => (
                        <Text key={index} style={{ marginBottom: 2 }}>{item}</Text>
                    ))}
                </View>
                <View style={{ width: '32%' }}>
                    {col3.map((item, index) => (
                        <Text key={index} style={{ marginBottom: 2 }}>{item}</Text>
                    ))}
                </View>
            </View>

            {/* Signature Section */}
            <SignatureSection data={data} type={type} />
        </View>
    );
};
